import * as React from 'react'
import PropTypes from 'prop-types'

import InfoCircle from './InfoCircle'
import cls from '../EventForm.module.scss'

const FieldTitle = ({ title, showInfoCircle, info }) => (
  <div className={cls.fieldTitle}>
    {title} {showInfoCircle && <InfoCircle info={info} />}
  </div>
)

FieldTitle.propTypes = {
  title: PropTypes.string,
  showInfoCircle: PropTypes.bool,
  info: PropTypes.string,
}

FieldTitle.defaultProps = {
  showInfoCircle: false,
}

export default FieldTitle
